import React from "react";
import styles from "./css/Header.module.css";
import { useNavigate } from "react-router-dom";
import headerImg from "../assets/header.png";

export const Header = () => {
    const navigate = useNavigate();

    const handleLoginClick = () => {
        navigate('/login');
    };

    return (
        <>
            <header className={styles.headerContainer}>
                <button 
                    className={styles.loginButton}
                    onClick={handleLoginClick}
                >
                    מתחברים כאן
                </button>

                <div className={styles.centerContent}>
                    <img
                        src="/Images/logoLetters.png"
                        alt="Forward Logo"
                        className={styles.logoImgLarge}
                    />
                </div>
            </header>
            <div className={styles.darkBar}></div>
        </>
    );
};
